import { Eye, TrendingUp, Zap } from 'lucide-react';

export const Positioning = () => {
  return (
    <section
      data-testid="positioning-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left Content */}
          <div>
            {/* Label */}
            <span className="font-manrope uppercase tracking-widest text-xs font-semibold text-primary">
              Our Positioning
            </span>

            {/* Heading */}
            <h2
              className="font-oswald uppercase tracking-tight font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mt-4"
              data-testid="positioning-headline"
            >
              <span className="text-gray-900">Built by platform insiders.</span>
              <br />
              <span className="text-primary">Designed for long-term growth.</span>
            </h2>

            {/* Copy */}
            <div className="mt-6 md:mt-8 space-y-4">
              <p className="font-manrope text-base md:text-lg text-gray-500 leading-relaxed">
                Loose Leaf Media was founded by former platform operators who have worked directly with creators, brands, and regional markets.
              </p>
              <p className="font-manrope text-base md:text-lg text-gray-500 leading-relaxed">
                We've seen what actually drives distribution, discovery, and scale — not from the outside, but from inside the platform ecosystem.
              </p>
              <p className="font-manrope text-base md:text-lg text-gray-800 leading-relaxed">
                Instead of selling social media as a channel, we design platform-led growth systems that connect content, creators, distribution, and monetization into one operating model.
              </p>
            </div>
          </div>

          {/* Right Content - Feature Cards */}
          <div className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-xl p-6 group hover:border-primary/50 hover:shadow-lg transition-all duration-300" data-testid="positioning-card-1">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Eye className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-oswald uppercase text-lg font-bold text-gray-900">Platform Insight</h3>
                  <p className="font-manrope text-sm text-gray-500 mt-2">
                    Understanding from inside the ecosystem, not outside observation.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 group hover:border-primary/50 hover:shadow-lg transition-all duration-300" data-testid="positioning-card-2">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <TrendingUp className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-oswald uppercase text-lg font-bold text-gray-900">System-First Approach</h3>
                  <p className="font-manrope text-sm text-gray-500 mt-2">
                    Growth systems that compound, not one-off campaigns that fade.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 group hover:border-primary/50 hover:shadow-lg transition-all duration-300" data-testid="positioning-card-3">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Zap className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-oswald uppercase text-lg font-bold text-gray-900">Integrated Model</h3>
                  <p className="font-manrope text-sm text-gray-500 mt-2">
                    Content, creators, distribution, and monetization — connected.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
